import React, { useEffect, useRef } from 'react';
import {
    Box, TextField, Button, Typography, MenuItem,
    Select,
    InputLabel,
} from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import trash from '../../assets/images/trash.svg';
import { useState, Downgraded, createState } from '@hookstate/core';
import CircularProgress from '@mui/material/CircularProgress';
import DataList from '../../sharedcomponents/dataList/dataList';
// import CKEditor from 'ckeditor4-react';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
// import EditTemplate from '../../modules/Invitation/editTemplate';
import { makeStyles } from '@mui/styles';
import validator from 'validator';
import { useParams } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import { FULL_PERMISSION } from '../../constants/Constant';

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';
import { useEventState } from '../../stores/eventStore';

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const settingState = createState({
    templateName: '',
    subject: '',
    ccEmail: '',
    ccEmail: '',
    bccEmail: '',
    editorHTML: '',
    status: 0,
    attachments: [],
    isDisable: false,
    fromEmail:'',
    fromDispalyName:''
});

const Status = [
    {
        value: 0,
        label: 'InActive',
    },
    {
        value: 1,
        label: 'Active',
    },
];
const Settings = () => {
    const classes = useStyles();
    const loading = useState(false);
    const settingList = useState([]);
    const openDialog = useState(false);
    const state = useState(settingState);
    const eventData = useState(null);
    const eventState = useEventState();
    // const openTemplateDialog = useState(false);
    const templateInfo = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const userInfo = useState(null);
    const [ccEmailErr, setCCEmailErr] = React.useState('');
    const [bccEmailErr, setBCCEmailErr] = React.useState('');
    const [fromEmailErr, setFromEmailErr] = React.useState('');

    
    const fileRef = useRef(null);
    // const [attachments, setAttachments] = React.useState([]);
    let params = useParams();
    const [disableBtn, setDisableBtn] = React.useState(true);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        userInfo.set(guserInfo);
        resetState();
        const moduleData = getModuleDetailsData(eventState.attach(Downgraded).get().eventDetail)
        state.set({ ...state.get(), fromEmail: moduleData }) 
    }, []);
    const getModuleDetailsData = (eventDetail) => {
         if (eventDetail?.moduleDetails) {
            const index = eventDetail.moduleDetails.findIndex((element) => {                
                if (element.moduleName === 'Invitations') {
                    return true; 
                }
            });
            return eventDetail.moduleDetails[index].fromInvitationEmail 
        }
    };
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
        getSettingsList();
    }, []);
    const resetState = () => {
        state.set({
            templateName: '',
            subject: '',
            ccEmail: '',
            bccEmail: '',
            editorHTML: '',
            attachments: [],
        });
    };

    const getSettingsList = () => {
        loading.set(true);
        let usersData = [];
        ApiHelper.get(APIURLConstants.GET_TEMPLATES(eventData.get().eventID))
            .then((res) => {
                let data = res.data.rows;
                if (data.length > 0) {
                    data.map((item) => {
                        usersData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'templateID',
                                    eventUsersID: item.templateID,
                                    width: '0.03',
                                },

                                {
                                    label: 'Name',
                                    key: 'name',
                                    name: item.templateName,
                                    showLabel: false,
                                    width: '0.14',  
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                {
                                    label: '',
                                    key: '',
                                    name: "",
                                    showLabel: false,
                                    width: '0.01',
                                },
                                {
                                    label: 'From Invitation Name',
                                    key: 'fromDisplayName',
                                    fromDisplayName: item.fromDisplayName,
                                    width: '0.14',
                                    inColumn: true,
                                    alignCenter: true
                                },
                                {
                                    label: '',
                                    key: '',
                                    name: "",
                                    showLabel: false,
                                    width: '0.01',
                                },
                                {
                                    label: 'From Invitation Email',
                                    key: 'fromEmail',
                                    fromEmail: item.fromEmail,
                                    width: '0.19',
                                    inColumn: true,
                                    alignCenter: true
                                },
                                {
                                    label: '',
                                    key: '',
                                    name: "",
                                    showLabel: false,
                                    width: '0.01',
                                },
                                {
                                    label: 'cc',
                                    key: 'ccEmailID',
                                    ccEmailID: item.ccEmailID,
                                    width: '0.22',
                                    inColumn: true,
                                    showTooltip: true,
                                    alignCenter: true
                                },

                                {
                                    label: 'bcc',
                                    key: 'bccEmailID',
                                    bccEmailID: item.bccEmailID,
                                    width: '0.15',
                                    inColumn: true,
                                    showTooltip: true,
                                },

                                {
                                    label: 'Status',
                                    key: 'status',
                                    status: item.status ? 'Active' : 'Inactive',
                                    width: '0.05',
                                    inColumn: true,
                                },

                                {
                                    label: 'Attachment',
                                    key: 'attachments',
                                    showLabel: false,
                                    width: '0.03',
                                    showAttachmentIcon:
                                        item.attachments.length > 0
                                            ? true
                                            : false,
                                },

                                {
                                    label: 'Action',
                                    key: 'edit',
                                    edit: 'Edit',
                                    width: '0.02',
                                },

                                { showChips: true },
                            ],

                            selected: false,
                        });
                    });
                }
                settingList.set(usersData);
                loading.set(false);
            })
            .catch((err) => {
                console.log(err);
                loading.set(false);
            });
    };
    const redirectToCreate = () => {
        openDialog.set(true);
    };
    // const handleClose = () =>
    // {
    //     openDialog.set(false);
    // };
    const editTemplate = (info) => {
        // openTemplateDialog.set(true);
        templateInfo.set(info.actualData);

        let editData = info.actualData;
        const moduleData = getModuleDetailsData(eventState.attach(Downgraded).get().eventDetail)
        state.set({
            templateName: editData.templateName,
            subject: editData.subject,
            ccEmail: editData.ccEmailID,
            bccEmail: editData.bccEmailID,
            editorHTML: editData.body,
            attachments: editData.attachments,
            status: editData.status,
            fromEmail: (editData.fromEmail != null && editData.fromEmail != "") ? editData.fromEmail : moduleData,
            fromDispalyName:editData.fromDisplayName
        })
        openDialog.set(true);
    };
    // const closeEditTemplate = () =>
    // {
    //     openTemplateDialog.set(false);
    //     templateInfo.set(null)
    // };
    const deleteSettingsList = () => {
        const selected = settingList
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Template first',
            });
        } else {
            let message =
                selected.length == settingList.get().length
                    ? 'Do you want to delete all Templates ?'
                    : 'Do you want to delete selected Templates ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handleConfirmation = () => {
        let deleteTemplates = [];
        settingList.get().map((user) => {
            if (user.selected === true) {
                deleteTemplates.push(user.actualData.templateID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_TEMPLATES, {
            ids: deleteTemplates.join(','),
            modifiedBy: userInfo.attach(Downgraded).get().userID,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Template deleted successfully',
                    });
                    setShowSearchRec(false);
                    getSettingsList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting template List ';
                }
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    // const [fileOpen, setFileOpen] = React.useState(false);
    // const handleFileOpen = () => {
    //     setFileOpen(true);
    // };
    // const handleFileClose = () => {
    //     setFileOpen(false);
    // };

    // useEffect(() => {
    //     setContainer(EMAIL_ATTACH_STORAGE_CONTAINER);
    // }, []);

    const handleFileChange = (e) => {
        var targetFiles = e.target.files;
        const files = state.attachments.attach(Downgraded).get()
            ? [...state.attachments.attach(Downgraded).get()]
            : [];
        //console.log('targetFiles', targetFiles);

        [...targetFiles].forEach((item) => {
            const file = item;
            let blob = file.slice(0, file.size, file.type);
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileName = file.name.substring(0, file.name.lastIndexOf('.'));
            let newFileName =
                fileName + '_' + new Date().getTime() + '.' + extension;
            const newFile = new File([blob], newFileName, {
                type: file.type,
            });
            files.push({
                fileName: newFileName,
                createdDate:
                    Helper.FormatYearDate(new Date()) +
                    ' ' +
                    Helper.FormatTime24(new Date()),
                createdBy: userInfo.attach(Downgraded).get().userID,
                isAvailableAtBlob: false,
                file: newFile,
            });
        });
        state.attachments.set(files);
        handleDisableBtn()
    };

    const saveTemplate = async (event) => {
        event.preventDefault();
        let templateState = state.get();
        const tempAttachment = [];

        if (templateState.templateName.trim().length === 0) {
            return false;
        }
        const ccValid = isCCEmailValidate();
        const bccValid = isBCCEmailValidate();
        if (ccValid == false || bccValid == false) {
            return false;
        }
        let template = templateInfo.attach(Downgraded).get()
        state.attachments.attach(Downgraded).get() &&
            state.attachments
                .attach(Downgraded)
                .get()
                .forEach((file) => {
                    tempAttachment.push({
                        InvitationID: 0,
                        TemplateID: 0,
                        FileName: file.fileName,
                        CreatedBy: userInfo.attach(Downgraded).get().userID,
                    });
                });

        let templateData = new FormData();
        templateData.append("TemplateID", template != null ? template.templateID : 0);
        templateData.append("EventID", eventData.attach(Downgraded).get().eventID);
        templateData.append("TemplateName", state.get().templateName);
        templateData.append("CCEmailID", state.get().ccEmail == null ? '' : state.get().ccEmail);
        templateData.append("BCCEmailID", state.get().bccEmail == null ? '' : state.get().bccEmail);
        templateData.append("Body", state.get().editorHTML ? encodeURIComponent(state.get().editorHTML) : '');
        templateData.append("Subject", state.get().subject);
        templateData.append("Status", template != null ? state.status.get() : 1);
        templateData.append("CreatedBy", userInfo.attach(Downgraded).get().userID);
        templateData.append("CreatedDate", Helper.FormatDateWithTime(new Date()));
        templateData.append("ModifiedBy", userInfo.attach(Downgraded).get().userID);
        templateData.append("ModifiedDate", Helper.FormatDateWithTime(new Date()));
        templateData.append("Attachments", JSON.stringify(tempAttachment));
        templateData.append("FromDisplayName",state.get().fromDispalyName == null ? '' :  state.get().fromDispalyName);
        templateData.append("FromEmail", state.get().fromEmail == null ? '' : state.get().fromEmail);

        state.attachments.attach(Downgraded).get() &&
            state.attachments
                .attach(Downgraded)
                .get()
                .filter((x) => x.isAvailableAtBlob == false)
                .forEach(async (file) => {
                    if (file.file) {
                        let newFile = file.file;
                        templateData.append('UploadAttachments', newFile);
                    }
                });

        // state.isDisable.set(true);
        ApiHelper.post(APIURLConstants.POST_TEMPLATES, templateData)
            .then((res) => {
                if (res.data) {
                    state.isDisable.set(false);
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Template Created successfully',
                    });
                }
                openDialog.set(false);
                getSettingsList();
                resetState();
                templateInfo.set(null)
            })
            .catch((err) => {
                console.log(err);
                state.isDisable.set(false);
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Error while adding Template',
                });
                templateInfo.set(null)

            });
    };

    const isCCEmailValidate = () => {
        let flag = true;
        const email =
            state.ccEmail.get() != null ? state.ccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setCCEmailErr('')
                    : setCCEmailErr('Please enter valid CC Email');
            });
        } else setCCEmailErr('');

        return flag;
    };
    const isFromEmailValidate = () => {
        let flag = true;
        const email =
            state.fromEmail.get() != null ? state.fromEmail.get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setFromEmailErr('')
                    : setFromEmailErr('Please enter valid From Email');
            });
        } else setFromEmailErr('');

        return flag;
    };

    const isBCCEmailValidate = () => {
        let flag = true;
        const email =
            state.bccEmail.get() != null ? state.bccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setBCCEmailErr('')
                    : setBCCEmailErr('Please enter valid BCC Email');
            });
        } else setBCCEmailErr('');
        return flag;
    };

    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };

    const handleRemove = (index) => {
        const values = [...state.attach(Downgraded).get().attachments];
        values.splice(index, 1);
        state.attachments.set(values);
        const dt = new DataTransfer();
        const input = document.getElementById('files');
        const { files } = input;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
        }
        input.files = dt.files; // Assign the updates list
        handleDisableBtn();
    };
    const handleDisableBtn = () => {
        if (templateInfo.attach(Downgraded).get() != null) {
            let templateData = templateInfo.attach(Downgraded).get();
            let prevData = {
                templateName: templateData.templateName,
                subject: templateData.subject,
                ccEmail: templateData.ccEmailID,
                bccEmail: templateData.bccEmailID,
                editorHTML: templateData.body,
                status: templateData.status,
                attachments: templateData.attachments,                
                fromEmail: templateData.fromEmail,
                fromDisplayName: templateData.fromDisplayName,
            }
            let currentData = {
                templateName: state.get().templateName,
                subject: state.get().subject,
                ccEmail: state.get().ccEmail === "" ? null : state.get().ccEmail,
                bccEmail: state.get().bccEmail === "" ? null : state.get().bccEmail,
                editorHTML: state.get().editorHTML === "" ? null : state.get().editorHTML,
                status: state.get().status,
                attachments: state.get().attachments,
                fromEmail: state.get().fromEmail === "" ? null : state.get().fromEmail,
                fromDisplayName: state.get().fromDispalyName,
            }
            // console.log(JSON.stringify(prevData) === JSON.stringify(currentData));
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }
    }

    const setEditorValue = (value) => {
        state.editorHTML.set(value);
        handleDisableBtn();
    }
    return (
        <>
            {openDialog.get() ? (
                <Box
                    className="otherContentBox"
                    component="form"
                    onSubmit={saveTemplate}>
                    <Box
                        sx={{
                            flex: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <Box
                                sx={{
                                    alignItems: 'center',
                                    width: '100%',
                                }}>
                                <TextField
                                    fullWidth
                                    required
                                    sx={{
                                        width: {
                                            xs: '100%',
                                            md: '25%',
                                        },
                                        marginTop: 2,
                                        marginRight: 2,
                                        marginBottom: 2,
                                    }}
                                    disabled={templateInfo.attach(Downgraded).get() != null ? true : false}
                                    size="small"
                                    id="outlined-required"
                                    inputProps={{ maxLength: 50 }}
                                    value={state.templateName.get()}
                                    onChange={(e) => {
                                        state.templateName.set(e.target.value);
                                    }}
                                    label="Template Name"
                                />
                                <TextField
                                    fullWidth                                    
                                    sx={{                                         
                                        marginRight: 2,                                        
                                    }}
                                    // disabled={templateInfo.attach(Downgraded).get() != null ? true : false}
                                    size="small"
                                    id="outlined-required"
                                    inputProps={{ maxLength: 50 }}
                                    value={state.fromDispalyName.get()}
                                    onChange={(e) => {
                                        state.fromDispalyName.set(e.target.value);
                                    }}
                                    label="From Invitation Name"
                                />
                                <TextField
                                    fullWidth
                                    sx={{
                                        marginTop: 2,
                                        marginBottom: 2,
                                        marginRight: 2,
                                    }}
                                    value={state.fromEmail.get()}
                                    size="small"
                                    id="outlined-required"
                                    label="From Invitation Email"
                                    onChange={(e) => {
                                        state.fromEmail.set(e.target.value);
                                        handleDisableBtn()
                                    }}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : isFromEmailValidate()
                                    }
                                    error={fromEmailErr.length > 0 ? true : false}
                                    helperText={
                                        fromEmailErr.length > 0 ? fromEmailErr : ''
                                    }
                                />
                                <TextField
                                    fullWidth
                                    sx={{
                                        marginRight: 2,
                                    }}
                                    value={state.ccEmail.get()}
                                    size="small"
                                    id="outlined-required"
                                    label="CC"
                                    onChange={(e) => {
                                        state.ccEmail.set(e.target.value);
                                        handleDisableBtn()
                                    }}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : isCCEmailValidate()
                                    }
                                    error={ccEmailErr.length > 0 ? true : false}
                                    helperText={
                                        ccEmailErr.length > 0 ? ccEmailErr : ''
                                    }
                                />
                                <TextField
                                    fullWidth
                                    sx={{
                                        marginTop: 2,
                                        marginRight: 2,
                                    }}
                                    value={state.bccEmail.get()}
                                    size="small"
                                    id="outlined-required"
                                    label="BCC"
                                    onChange={(e) => {
                                        state.bccEmail.set(e.target.value);
                                        handleDisableBtn()

                                    }}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : isBCCEmailValidate()
                                    }
                                    error={
                                        bccEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        bccEmailErr.length > 0
                                            ? bccEmailErr
                                            : ''
                                    }
                                />

                                <TextField
                                    fullWidth
                                    required
                                    sx={{
                                        marginTop: 2,
                                        marginRight: 2,
                                    }}
                                    value={state.subject.get()}
                                    size="small"
                                    id="outlined-required"
                                    label="Subject"
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => {
                                        state.subject.set(e.target.value);
                                        handleDisableBtn()

                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            flexDirection: 'row',
                            marginTop: 1,
                            width: { xs: '100%', md: '100%' },
                        }}>
                        {/* <CKEditor
                            data={state.editorHTML.attach(Downgraded).get()}
                            onChange={(event) =>
                                state.editorHTML.set(event.editor.getData())
                            }
                            config={{
                                removeButtons: 'Subscript,Superscript',
                                extraAllowedContent: '*{*};*(*);span{!color}'
                            }}
                        /> */}
                        <TinyMCEEditor
                            value={state.editorHTML.attach(Downgraded).get()}
                            setValue={setEditorValue}
                            enableImageEncode={true}
                        />
                        {/* <CKEditor
                            editor={Editor}
                            config={{
                                image: {
                                    upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                                },
                                removeButtons: 'Subscript,Superscript',
                                extraAllowedContent: '*{*};*(*);span{!color}'
                            }}
                            data={state.editorHTML.attach(Downgraded).get()}
                            onChange={(event, editor) =>
                            {
                                console.log(event);
                                state.editorHTML.set(editor.getData())
                                handleDisableBtn()

                            }}
                        /> */}
                    </Box>
                    {/* Start Display Attachment List Here */}
                    {templateInfo.attach(Downgraded).get() != null && (
                        <FormControl
                            sx={{ minWidth: '100%', marginTop: '10px' }}>
                            <InputLabel id="demo-simple-select-label">
                                Status
                            </InputLabel>
                            <Select
                                size="small"
                                required
                                fullWidth
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                input={<OutlinedInput label="Status" />}
                                sx={{ minWidth: '40%' }}
                                value={state.status.get()}
                                onChange={(e) => {
                                    state.status.set(e.target.value);
                                    handleDisableBtn()

                                }}>
                                {Status &&
                                    Status.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginTop: '10px',
                        }}>
                        <Box flex={0.98}>
                            <Typography
                                variant="h4"
                                fontSize={{ xs: '12px', md: '16px' }}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                pb={1}>
                                Attachments
                            </Typography>
                        </Box>
                        <label>
                            <Box
                                sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    alignSelf: 'center',
                                    display: 'flex',
                                }}
                                flex={0.03}
                                id="imageUpload">
                                <AddCircleRoundedIcon
                                    sx={{ color: '#008000' }}
                                />
                                <input
                                    type="file"
                                    id="files"
                                    // value={state.attachments.attach(Downgraded).get()}
                                    multiple={true}
                                    hidden
                                    onChange={handleFileChange}
                                    ref={fileRef}
                                />
                            </Box>
                        </label>
                    </Box>

                    {state.attachments.attach(Downgraded).get() &&
                        state.attachments.attach(Downgraded).get().length > 0 ? (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    flex: 1,
                                    marginTop: 1,
                                    backgroundColor: '#f8f8f8',
                                }}>
                                <Box
                                    flex={0.75}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={12}
                                        fontWeight={500}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 3 }}
                                        color={'primary'}
                                        pb={1}>
                                        File Name
                                    </Typography>
                                </Box>
                                <Box
                                    flex={0.2}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={12}
                                        fontWeight={500}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 3 }}
                                        color={'primary'}
                                        pb={1}>
                                        Created Date
                                    </Typography>
                                </Box>
                            </Box>
                            {state.attachments.attach(Downgraded).get() &&
                                state.attachments
                                    .attach(Downgraded)
                                    .get()
                                    .map((file, idx) => {
                                        let extension = file.fileName.substring(file.fileName.lastIndexOf('.') + 1);
                                        let fileName = file.fileName.substring(0, file.fileName.lastIndexOf('.'));
                                        return (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    marginTop: 1,
                                                    backgroundColor: '#f8f8f8',
                                                }}>
                                                <Box
                                                    flex={0.75}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'start',
                                                        lineHeight: '0',
                                                    }}>
                                                    <Typography
                                                        variant="h2"
                                                        fontSize={14}
                                                        fontWeight={400}
                                                        paddingLeft={1}
                                                        paddingTop={1}
                                                        sx={{ paddingLeft: 3 }}
                                                        pb={1}>
                                                        {Helper.removeLastChars(fileName, 14) + '.' + extension}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    flex={0.2}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'start',
                                                        lineHeight: '0',
                                                    }}>
                                                    <Typography
                                                        variant="h2"
                                                        fontSize={14}
                                                        fontWeight={400}
                                                        paddingLeft={1}
                                                        paddingTop={1}
                                                        sx={{ paddingLeft: 3 }}
                                                        pb={1}>
                                                        {`${Helper.FormatYearDate(
                                                            new Date()
                                                        )} ${Helper.FormatTime24(
                                                            new Date()
                                                        )}`}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flex: 0.05,
                                                    }}>
                                                    <Box
                                                        component="img"
                                                        className={
                                                            classes.sedanBlack
                                                        }
                                                        alt="logo."
                                                        src={trash}
                                                        onClick={() =>
                                                            handleRemove(idx)
                                                        }
                                                    />
                                                </Box>
                                            </Box>
                                        );
                                    })}{' '}
                        </>
                    ) : null}
                    {/* End Display Attachment List Here */}
                    <Box
                        sx={{
                            flex: 0.3,
                            display: 'flex',
                            alignItems: 'end',
                            justifyContent: 'end',
                            marginTop: {
                                xs: 1,
                            },
                        }}>
                        <Button
                            variant="outlined"
                            disabled={state.isDisable.get()}
                            onClick={() => {
                                openDialog.set(false);
                                resetState();
                                templateInfo.set(null)
                            }}
                            style={{ fontSize: 13 }}>
                            Cancel
                        </Button>
                        <Button
                            disabled={templateInfo.attach(Downgraded).get() != null ? disableBtn : false}
                            variant="contained"
                            type="submit"
                            style={{ fontSize: 13, marginLeft: 10 }}>
                            {templateInfo.attach(Downgraded).get() != null ? 'Update' : 'Save'}
                        </Button>
                    </Box>
                </Box>
            ) : (
                <>
                    {loading.get() ? (
                        <Box
                            sx={
                                loading.get()
                                    ? {
                                        paddingTop: '20%',
                                        paddingBottom: '20%',
                                        textAlign: 'center',
                                    }
                                    : ''
                            }
                            className={loader}>
                            <CircularProgress />
                        </Box>
                    ) : settingList.get() ? (
                        <Box >
                            <DataList
                                data={settingList.attach(Downgraded).get()}
                                // onCheckSelect={onCheckSelect}
                                editRow={editTemplate}
                                handleClick={redirectToCreate}
                                title={''}
                                buttonTitle={'Add'}
                                deleteRows={deleteSettingsList}
                                showSearch={true}
                                searchLabel={'Search'}
                                showSearchRec={showSearchRec}
                                setShowSearchRec={setShowSearchRec}
                                modPermission={FULL_PERMISSION}
                            />
                        </Box>
                    ) : null}
                    {/* {openTemplateDialog.get() && (
                        <EditTemplate
                            open={openTemplateDialog.get()}
                            templateInfo={templateInfo.attach(Downgraded).get()}
                            title="Edit Template "
                            handleClose={closeEditTemplate}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getSettingsList={getSettingsList}
                            settingList={true}
                        />
                    )} */}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() => {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                </>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};
export default Settings;
